import { useState } from 'react';
import './nestedTags.css';
import CharCount from '../charCount/CharCount';

export default function NestedTags({ packData, setPackData, index }) {
    const [pickup, setPickup] = useState({ name: '', location: '' });
    const [meetup, setMeetup] = useState({ name: '', location: '' });
    const mapUrlPattern = /^https?:\/\/(?:www\.)?maps\.app\.goo\.gl\/([A-Za-z0-9_-]{11,17})(?:[\/?].*)?$/i;
    const [dragIndex, setDragIndex] = useState(null);

    function addMeetup() {
        if (meetup.name === '') {
            alert('Please enter the meetup name');
        } else if (meetup.location === '') {
            alert('Please enter the meetup location');
        } else if (!mapUrlPattern.test(meetup.location)) {
            alert('Enter proper map location URL');
        } else {
            setPackData(function (prevState) {
                const updatedArrya = prevState.price.map(function (item, itemKey) {
                    if (index === itemKey) {
                        return {
                            ...item,
                            meetupPoint: [...(item.meetupPoint || []), meetup]
                        };
                    }
                    return item;
                });
                return { ...prevState, price: [...updatedArrya] };
            });
            setMeetup({ name: '', location: '' });
        }
    }
    function addPickup() {
        if (pickup.name === '') {
            alert('Please enter the pickup name');
        } else if (pickup.location === '') {
            alert('Please enter the pickup location');
        } else if (!mapUrlPattern.test(pickup.location)) {
            alert('Enter proper map location URL');
        } else {
            setPackData(function (prevState) {
                const updatedArrya = prevState.price.map(function (item, itemKey) {
                    if (index === itemKey) {
                        return {
                            ...item,
                            pickupLocation: [...(item.pickupLocation || []), pickup]
                        };
                    }
                    return item;
                });
                return { ...prevState, price: [...updatedArrya] };
            });
            setPickup({ name: '', location: '' });
        }
    }
    function removePickup(text) {
        // const tempArray = packData.price[index].pickupLocation;
        // let index = tempArray.indexOf(text);
        // tempArray.splice(index, 1);
        setPackData(function (prevState) {
            console.log('1');
            const updatedArrya = prevState.price.map(function (item, itemKey) {
                if (index === itemKey) {
                    const tempArray = [...item.pickupLocation];
                    const textIndex = tempArray.indexOf(text);
                    tempArray.splice(textIndex, 1);
                    console.log(tempArray);
                    return { ...item, pickupLocation: [...tempArray] };
                }
                return item;
            });
            return { ...prevState, price: [...updatedArrya] };
        });
    }

    function removeMeetUp(text) {
        // const tempArray = packData.price[index].pickupLocation;
        // let index = tempArray.indexOf(text);
        // tempArray.splice(index, 1);
        setPackData(function (prevState) {
            console.log('Meetup');
            const updatedArrya = prevState.price.map(function (item, itemKey) {
                if (index === itemKey) {
                    const tempArray = [...item.meetupPoint];
                    const textIndex = tempArray.indexOf(text);
                    tempArray.splice(textIndex, 1);
                    console.log(tempArray);
                    return { ...item, meetupPoint: [...tempArray] };
                }
                return item;
            });
            return { ...prevState, price: [...updatedArrya] };
        });
    }

    const onDragStart = (index) => {
        setDragIndex(index);
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (dropIndex) => {
        if (dragIndex === null || dragIndex === dropIndex) return;
        const updatedPickupLocation = [...packData.price[index].pickupLocation];
        const draggedItem = updatedPickupLocation[dragIndex];
        updatedPickupLocation.splice(dragIndex, 1);
        updatedPickupLocation.splice(dropIndex, 0, draggedItem);
        setPackData((prev) => ({
            ...prev,
            price: prev.price.map((priceItem, priceIndex) => {
                if (priceIndex === index) {
                    return {
                        ...priceItem,
                        pickupLocation: updatedPickupLocation
                    };
                }
                return priceItem;
            })
        }));
        setDragIndex(null);
    };

    const onDropMeetup = (dropIndex) => {
        if (dragIndex === null || dragIndex === dropIndex) return;
        const updatedPickupLocation = [...packData.price[index].meetupPoint];
        const draggedItem = updatedPickupLocation[dragIndex];
        updatedPickupLocation.splice(dragIndex, 1);
        updatedPickupLocation.splice(dropIndex, 0, draggedItem);
        setPackData((prev) => ({
            ...prev,
            price: prev.price.map((priceItem, priceIndex) => {
                if (priceIndex === index) {
                    return {
                        ...priceItem,
                        meetupPoint: updatedPickupLocation
                    };
                }
                return priceItem;
            })
        }));
        setDragIndex(null);
    };

    return (
        <div>
            {packData.group === 'vehicle' || packData.datesType === 'custom' ? (
                <>
                    {' '}
                    <div className='itineraryInDiv custom'>
                        <label className='itineraryLabel'>Meetup Point</label>
                        <div className='itineraryDiv1'>
                            <input
                                type='text'
                                name='name'
                                onChange={(e) =>
                                    setMeetup((prev) => ({
                                        ...prev,
                                        [e.target.name]: e.target.value
                                    }))
                                }
                                placeholder='Ex- Indiranagar Bus stop (9:00 PM), Enter and press Add Pickup to add'
                                value={meetup.name}
                                className='nestedTagInput'
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         addPickup();
                                //     }
                                // }}
                            ></input>
                            <CharCount string={meetup.name} min={10} limit={60} />
                            <div className='itineraryInputDiv'>
                                <input
                                    type='text'
                                    name='location'
                                    onChange={(e) =>
                                        setMeetup((prev) => ({
                                            ...prev,
                                            [e.target.name]: e.target.value
                                        }))
                                    }
                                    placeholder='Google location'
                                    value={meetup.location}
                                    className='nestedTagInput'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            addMeetup();
                                        }
                                    }}
                                ></input>
                                <button type='button' onClick={addMeetup} className='nestedTagOkBtn blueBtn'>
                                    Add Meetup
                                </button>
                            </div>
                        </div>
                    </div>
                    {packData?.price[index]?.meetupPoint?.length > 0 && (
                        <div className='tagContainer'>
                            <div className='tagOutDiv'>
                                {packData.price[index].meetupPoint.map((text, index) => {
                                    return (
                                        <div
                                            key={index}
                                            draggable
                                            onDrag={() => onDragStart(index)}
                                            onDragOver={onDragOver}
                                            onDrop={() => onDropMeetup(index)}
                                            className='tagDiv'
                                        >
                                            <p className='tagP'>{text.name}</p>
                                            <button
                                                style={{ cursor: 'pointer' }}
                                                className='tagButton'
                                                onClick={(e) => removeMeetUp(text)}
                                            >
                                                X
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <div className='itineraryInDiv custom'>
                        <label className='itineraryLabel'>Pickup Location</label>
                        <div className='itineraryDiv1'>
                            <input
                                type='text'
                                name='name'
                                onChange={(e) =>
                                    setPickup((prev) => ({
                                        ...prev,
                                        [e.target.name]: e.target.value
                                    }))
                                }
                                placeholder='Ex- Indiranagar Bus stop (9:00 PM), Enter and press Add Pickup to add'
                                value={pickup.name}
                                className='nestedTagInput'
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         addPickup();
                                //     }
                                // }}
                            ></input>
                            <CharCount string={pickup.name} min={10} limit={60} />
                            <div className='itineraryInputDiv'>
                                <input
                                    type='text'
                                    name='location'
                                    onChange={(e) =>
                                        setPickup((prev) => ({
                                            ...prev,
                                            [e.target.name]: e.target.value
                                        }))
                                    }
                                    placeholder='Google location'
                                    value={pickup.location}
                                    className='nestedTagInput'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            addPickup();
                                        }
                                    }}
                                ></input>
                                <button type='button' onClick={addPickup} className='nestedTagOkBtn blueBtn'>
                                    Add Pickup
                                </button>
                            </div>
                        </div>
                    </div>
                    {packData?.price[index]?.pickupLocation?.length > 0 && (
                        <div className='tagContainer'>
                            <div className='tagOutDiv'>
                                {packData.price[index].pickupLocation.map((text, index) => {
                                    return (
                                        <div
                                            key={index}
                                            draggable
                                            onDrag={() => onDragStart(index)}
                                            onDragOver={onDragOver}
                                            onDrop={() => onDrop(index)}
                                            className='tagDiv'
                                        >
                                            <p className='tagP'>{text.name}</p>
                                            <button
                                                style={{ cursor: 'pointer' }}
                                                className='tagButton'
                                                onClick={(e) => removePickup(text)}
                                            >
                                                X
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}{' '}
                </>
            )}
        </div>
    );
}
